import { render } from "./business-detail.vue?vue&type=template&id=0ecbf678"
import script from "./business-detail.vue?vue&type=script&lang=js"
export * from "./business-detail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/main/operation/business/business-detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ecbf678"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ecbf678', __exports__)) {
    console.log('reload')
    api.reload('0ecbf678', __exports__)
  }
  
  module.hot.accept("./business-detail.vue?vue&type=template&id=0ecbf678", () => {
    console.log('re-render')
    api.rerender('0ecbf678', render)
  })

}


export default __exports__